import styled from "styled-components";
import { Button as ButtonAntd, Input } from "antd";

export const VerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  height: 100%;
  justify-content: center;
`;

export const VerificationTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--orange-150);
  margin-bottom: 24px;
`;

export const VerificationCardContainer = styled.div`
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const VerificationCardContent = styled.div`
  background: #fff;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #eaeaea;
  margin-bottom: 20px;
`;

export const BoxButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const VerificationCardTitle = styled.div`
  font-size: 18px;
  margin-bottom: 16px;
  color: #555;
`;

export const VerificationCardSubtitle = styled.p`
  margin-bottom: 5px;
`;

export const VerificationPhoneNumber = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: black;
  padding: 8px 0;
`;

export const VerificationCodeContainer = styled.div`
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
  padding: 30px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const VerificationCodeTitle = styled.div`
  font-size: 18px;
  margin-bottom: 25px;
  color: #555;
`;

export const VerificationCodeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px auto;
`;

export const VerificationCodeInput = styled(Input)`
  font-size: 24px;
  text-align: center;
  height: 60px;
  border-radius: 8px;
  border: 1px solid #eaeaea !important;
`;

export const VerificationResendContainer = styled.div`
  margin-top: 15px;
  color: #666;
  font-size: 14px;
`;

export const ResendButton = styled(ButtonAntd)`
  &[disabled] {
    color: rgba(0, 0, 0, 0.25);
    background-color: transparent;
    border-color: transparent;
    text-shadow: none;
    box-shadow: none;
  }
`;

export const TimerText = styled.span`
  color: #ff4d4f;
  font-weight: 500;
  margin-left: 4px;
`;

export const InfoIcon = styled.i`
  margin-left: 5px;
  color: #1890ff;
  cursor: pointer;
`;

export const ButtonPin = styled(ButtonAntd)`
  width: 100%;
  border-radius: 6px;
  background-color: var(--orange-150);
  color: white;
  height: 3rem;
  font-weight: 500;
  font-size: 1rem;

  &&&:hover,
  &&&:focus,
  &&&:active,
  &&&:focus-within {
    background-color: var(--orange-250);
    color: white;
  }

  &[disabled] {
    color: rgba(0, 0, 0, 0.45);
    cursor: not-allowed;
    background-color: #f5f5f5;
  }

  &:hover:not([disabled]) {
    color: var(--orange-250);
    border-color: var(--orange-250);
  }
`;

export const VerificationHeader = styled.div`
  padding: 10px 0;
  text-align: center;
  margin-bottom: 20px;

  h3 {
    font-size: 18px;
    color: var(--orange-150);
    margin-bottom: 5px;
  }

  p {
    color: #666;
    margin: 0;
  }
`;

export const ButtonCancel = styled(ButtonAntd)`
  margin-top: 10px;
  background-color: var(--gray-150);
  border-radius: 6px;
  font-weight: 400;
  &&&:hover,
  &&&:focus,
  &&&:active,
  &&&:focus-within {
    background-color: var(--gray-250);
    color: white;
  }
`;

export const InfoText = styled.p`
  font-size: 12px;
  color: #888;
  margin-top: 15px;
  text-align: center;
`;
